import xpath from "xpath";
import { Util, OBJECT_SEPARATOR, ARRAY_SEPARATOR } from "@orion2/utils/datamodule.utils";
import { TaskNamespace } from "@orion2/msm-formatter/types/MsmTask";

export class Classification {
  public static extractS1000D(xmlNode: Node): string {
    const value = this.getClassificationString(xmlNode);
    const changed = xpath.select("string(timeLimitCategory/@changeMark)", xmlNode).length > 0;
    return value + OBJECT_SEPARATOR + changed;
  }

  /**
   * Stringify the classification according to bussiness rules
   */
  private static getClassificationString(taskXml: Node): string {
    const timeLimitCategory: string = Util.cleanXml(
      xpath.select("string(timeLimitCategory/@timeLimitCategoryValue)", taskXml)
    );
    const worthinessLimitCategory: string = Util.cleanXml(
      xpath.select("string(./@worthinessLimit)", taskXml)
    );
    const classificationMap = {
      mandatory: "1 - Mandatory",
      recommended: "2 - Recommended",
      none: "None",
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "1": "1 - Mandatory",
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "2": "2 - Recommended"
    };

    if (
      !timeLimitCategory &&
      ["mandatory", "recommended", "none"].includes(worthinessLimitCategory)
    ) {
      return classificationMap[worthinessLimitCategory];
    }
    if (!worthinessLimitCategory && ["1", "2"].includes(timeLimitCategory)) {
      return classificationMap[timeLimitCategory];
    }
    return [timeLimitCategory, worthinessLimitCategory].filter(Boolean).join(" - ");
  }

  public static unserialize(data: string): TaskNamespace.Classification {
    if (data !== undefined) {
      const val = data.split(OBJECT_SEPARATOR);
      return {
        value: val[0],
        changed: val[1] === "true"
      };
    }
  }
}
